export default function SiteFooter() {
  return (
    <footer className="bg-ihc-ink font-montserrat">
      <div className="mx-auto max-w-3xl px-5 py-10 text-center text-base font-bold text-white leading-relaxed">
        <p>Operational infrastructure for growing home care agencies.</p>
        <p>After-Hours On Call - Scheduling -Recruiting- Virtual Assistants</p>
        <p className="mt-4">
          &copy; 2026 Home Care Admin Experts. All right reserved.
          <br />
          Supporting Agencies since 2020.
        </p>
      </div>
    </footer>
  );
}
